import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import {
  PROFILE_FETCH_PENDING,
  PROFILE_UPDATE_PENDING,
  PHOTO_UPDATE_PENDING,
} from '../../actions/index'
import '../sign-up/sign-up.css'

export default class AccountDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      nickname: '',
      delete_account: false,
      photo: '',
      newPhoto: null,
    }
  }

  componentWillMount() {
    this.props.handleAction(PROFILE_FETCH_PENDING)
  }

  componentWillReceiveProps(nextProps) {
    const { firstName, lastName, nickname, email, photoUrl } = nextProps

    this.setState({
      firstName,
      lastName,
      nickname,
      email,
      photo: photoUrl,
    })
  }

  componentDidUpdate() {
    if (this.state.newPhoto) {
      this.props.handleAction(PHOTO_UPDATE_PENDING, {
        photo: this.state.newPhoto,
      })
    }
  }

  firstNameHandler = (e) => {
    this.setState({
      firstName: e.target.value,
    })
  }

  lastNameHandler = (e) => {
    this.setState({
      lastName: e.target.value,
    })
  }

  nicknameHandler = (e) => {
    this.setState({
      nickname: e.target.value,
    })
  }

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  imageHandler = (e) => {
    if (e.target.files) {
      const reader = new FileReader()
      const input = e.target
      let data = ''

      reader.onload = () => {
        data = reader.result

        this.setState({
          newPhoto: data,
        })
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  deleteAccount = () => {
    this.setState({
      delete_account: true,
    })
  }

  updateAccountData = (e) => {
    e.preventDefault()

    const { email, firstName, lastName, nickname, photo, newPhoto } = this.state

    this.props.handleAction(PROFILE_UPDATE_PENDING, {
      email,
      firstName,
      lastName,
      nickname,
    })
  }

  renderDeleteAccount() {
    const { t } = this.props

    return (
      <div>
        <div className="xs-block xs-text-center">
          <div className="xs-text-3 xs-my3">{t('WAS_IT')}</div>
          <div className="xs-mb6 xs-mt5">{t('DELETE_ACCOUNT_TEXT')} <span className="xs-text-red">{t('LET_US_KNOW_RED')}</span></div>
        </div>
        <div className="xs-block xs-mt4">
          <button className="btn xs-py3 xs-col-12">{t('DELETE_ACCOUNT')}</button>
          <button className="xs-py3 xs-my2 border-gray xs-fill-gray-lighter xs-border xs-col-12">{t('CANCEL')}</button>
        </div>
      </div>
    )
  }

  renderEditDetails() {
    const { t } = this.props
    const { firstName, lastName, nickname, email, photo, newPhoto } = this.state
    let imgSrc = 'https://media.timeout.com/images/103003836/160/120/image.jpg'

    if (newPhoto) {
      imgSrc = newPhoto
    } else if (photo !== '') {
      imgSrc = photo
    }

    return (
      <div>
        <div className="subtitle xs-text-7 xs-text-gray xs-mb5 xs-mt3 xs-mb4">
          {t('EDIT_DETAILS_HERE')}
        </div>

        <form onSubmit={this.updateAccountData}>
          { typeof firstName === 'string' &&
            <input
              type="text"
              value={firstName}
              autoComplete="given-name"
              onChange={this.firstNameHandler}
              className="xs-py3 xs-mb0 xs-py3 xs-fit text-input xs-border-bottom-none"
              placeholder={t('FIRST_NAME')}
            />
          }
          { typeof lastName === 'string' &&
            <input
              type="text"
              value={lastName}
              autoComplete="family-name"
              onChange={this.lastNameHandler}
              className="xs-py3 xs-mb0 xs-py3 xs-fit text-input xs-border-bottom-none"
              placeholder={t('LAST_NAME')}
            />
          }
          { typeof nickname === 'string' &&
            <input
              type="text"
              value={nickname}
              autoComplete="nickname"
              onChange={this.nicknameHandler}
              className="xs-py3 xs-mb0 xs-py3 xs-fit text-input xs-border-bottom-none"
              placeholder={t('SCREEN_NAME')}
            />
          }
          { typeof email === 'string' &&
            <input
              type="text"
              value={email}
              autoComplete="email"
              onChange={this.emailHandler}
              className="xs-py3 xs-mb0 xs-py3 xs-fit text-input xs-mb4"
              placeholder={t('EMAIL')}
            />
          }

          <button type="submit" className="xs-fill-blue-cta rounded xs-border-none cond caps xs-text-white xs-py3 xs-col-12">{t('SAVE_CHANGES')}</button>
        </form>

        <div className="subtitle xs-text-center xs-mt4 xs-text-black xs-text-6">
          {t('UPLOAD_PIC')}
        </div>

        <label htmlFor="file-upload" className="xs-mt3">
          <img src={imgSrc} alt="Profile avatar" width="160" />
        </label>
        <div className="xs-mt3 xs-text-center">
          <input id="file-upload" type="file" accept="image/*" onChange={this.imageHandler} />
          <div className="xs-mt2 xs-text-center long-text">{t('CHOOSE_PHOTO')}</div>
        </div>

        {/* <div className="clearfix xs-mt2 xs-py3 xs-border-top">
          <Link onClick={this.deleteAccount} className="cursor-pointer xs-float-right">{t('CLOSE_ACCOUNT')}</Link>
        </div> */}

      </div>
    )
  }

  render() {
    return (
      <div>
        { this.state.delete_account ? this.renderDeleteAccount() : this.renderEditDetails() }
      </div>
    )
  }
}

AccountDetails.propTypes = {
  t: PropTypes.func.isRequired,
  handleAction: PropTypes.func.isRequired,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  nickname: PropTypes.string,
  email: PropTypes.string,
  photoUrl: PropTypes.string,
}

AccountDetails.defaultProps = {
  firstName: '',
  lastName: '',
  nickname: '',
  email: '',
  photoUrl: '',
}



// WEBPACK FOOTER //
// ./src/components/account-details/account-details.js